import styled, { css } from 'styled-components';

interface Props {
	isInverted?: boolean;
	isVertical?: boolean;
}

function getAnimation(isInverted?: boolean, isVertical?: boolean) {
	if (isInverted) {
		return isVertical ? 'vertical-drag-btn-anim-inverted' : 'drag-btn-anim-inverted';
	}

	return isVertical ? 'vertical-drag-btn-anim' : 'drag-btn-anim';
}

const AnimationMixin = (name: string, startTranslate: string, endTranslate: string) => css`
	@keyframes ${name} {
		0% {
			opacity: 0;
			transform: ${startTranslate};
		}

		20% {
			opacity: 1;
		}

		60% {
			opacity: 1;
			transform: ${endTranslate};
		}

		100% {
			opacity: 0;
			transform: ${endTranslate};
		}
	}
`;

export const AnimationWrapper = styled.div<Props>`
	user-select: none;
	pointer-events: none;
	animation: 1.3s ease-in-out 0s infinite ${props => getAnimation(props.isInverted, props.isVertical)};

	${AnimationMixin('drag-btn-anim', 'translateX(-5px)', 'translateX(7px)')}
	${AnimationMixin('drag-btn-anim-inverted', 'translateX(5px)', 'translateX(-7px)')}
	${AnimationMixin('vertical-drag-btn-anim', 'translateY(-5px)', 'translateY(7px)')}
	${AnimationMixin('vertical-drag-btn-anim-inverted', 'translateY(5px)', 'translateY(-7px)')}
`;
